// ISP-9999 fe-unverified-banner-and-cues: the one shared place that decides
// what a gated action (purchase, publish/share, chat send, invite, email
// change, referral, username set, clone) shows when the backend refuses it
// with 403 {code: "email_unverified"} (see users/permissions.py
// IsVerifiedEmail on the backend). Centralized here — rather than duplicated
// per action — so every current AND future gated surface gets the same
// visible cue instead of failing silently, by routing through the single
// shared axios instance's response interceptor (services/request.js).
import { toast } from "react-toastify";

export const EMAIL_UNVERIFIED_CODE = "email_unverified";
export const EMAIL_UNVERIFIED_CUE_EVENT = "iyuga:email-unverified-cue";

export const isEmailUnverifiedError = (error) =>
  error?.response?.status === 403 &&
  error?.response?.data?.code === EMAIL_UNVERIFIED_CODE;

// Fired once per refused action: toasts a clear, actionable message and lets
// the persistent banner (UnverifiedBanner) react (e.g. a brief highlight) via
// a DOM event, so the two surfaces stay in sync without a shared redux slice.
export const showEmailUnverifiedCue = () => {
  toast.error(
    "Please confirm your email to use this — check the banner above to resend the link.",
    { toastId: EMAIL_UNVERIFIED_CODE }
  );
  if (typeof window !== "undefined" && typeof window.dispatchEvent === "function") {
    window.dispatchEvent(new Event(EMAIL_UNVERIFIED_CUE_EVENT));
  }
};
